import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';
import { useDispatch } from 'react-redux';
import { API } from '_helpers';
import { useTypedSelector } from '../../hooks';
import { cleanImage, showImage } from '../../store';

const GalleryImage = () => {
  const dispatch = useDispatch();
  const image: Image = useTypedSelector((state) => state.image);
  const images: IGallery[] = useTypedSelector((state) => state.images);
  const handleClose = () => dispatch(cleanImage());
  const { locale } = useRouter();

  const count = images.length;
  const current = image.index;
  const next = current !== count - 1 ? current + 1 : current;
  const prev = current !== 0 ? current - 1 : current;

  const handleNext = () => {
    dispatch(
      showImage({
        ...image,
        index: next,
        link:
          images[next]?.gallery_category?.slug === 'videos'
            ? images[next].link
            : API + images[next].media.url,
        loading: true,
        category:
          images[next]?.gallery_category?.slug === 'videos' ? 'videos' : '',
      })
    );
  };

  const handlePrev = () => {
    dispatch(
      showImage({
        ...image,
        index: prev,
        link:
          images[prev]?.gallery_category?.slug === 'videos'
            ? images[prev].link
            : API + images[prev].media.url,
        loading: true,
        category:
          images[prev]?.gallery_category?.slug === 'videos' ? 'videos' : '',
      })
    );
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={image.open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={image.open}>
        <Box>
          <Container>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                height: '100vh',
                width: '100%',
                position: 'relative',
                p: { xs: 0, md: 4 },
              }}
            >
              <Box sx={{ position: 'absolute', right: 20, top: 20 }}>
                <IconButton
                  onClick={handleClose}
                  sx={{ bgcolor: 'error.main' }}
                >
                  <CloseFullscreenIcon sx={{ color: 'white' }} />
                </IconButton>
              </Box>
              <IconButton onClick={handlePrev}>
                <ArrowBackIosNewIcon sx={{ color: 'white' }} />
              </IconButton>
              <Stack
                sx={{
                  height: '100%',
                  width: '100%',
                  position: 'relative',
                }}
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  sx={{
                    position: 'absolute',
                    left: { xs: '30%', md: '50%' },
                    top: '45%',
                  }}
                >
                  <Typography color="#fff" variant="h2" textAlign="center">
                    {locale === 'fr' ? 'Chargement...' : 'Loading...'}
                  </Typography>
                </Box>
                {image.category === 'videos' ? (
                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      position: 'relative',
                      zIndex: 5,
                    }}
                  >
                    <iframe
                      width="100%"
                      title="video"
                      src={`https://www.youtube.com/embed/${image.link}`}
                      frameBorder={0}
                      allowFullScreen
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      height="100%"
                    />
                  </Box>
                ) : (
                  <Image
                    src={image.link}
                    alt={image.link}
                    layout="fill"
                    objectFit="contain"
                    objectPosition="center"
                  />
                )}
              </Stack>
              <IconButton onClick={handleNext}>
                <ArrowForwardIosIcon sx={{ color: 'white' }} />
              </IconButton>
            </Stack>
          </Container>
        </Box>
      </Fade>
    </Modal>
  );
};

export default GalleryImage;
